# Всплывающие окно с новостью
class window.PagePopup
  constructor: ->
    self = this
    @$popupBlock = $('.popup-overlay') # само всплывающие окно
    @$popupBlockContent = $('.popup-overlay__content') # блок, куда вставляется основной контент новости
    @popupBlockOpenClass = 'popup-overlay--active' # Класс для появления всплывающего окна
    @activeHiddenField
    window.defaultPageTitle = document.title # title по умолчанию
    @shiftHeight = 56
    @prevHref = window.location.pathname + window.location.search
    @prevTitle = document.title
    @windowPosition = 0

    @popupPageOpen = false # флаг который показывает, открыто ли всплывающие окно
    @popupPageAnimate = false # Флаг показывающие, что страница находится в процессе анимации открытия
    @animationFlag = false
    @activeFlag = false
    @activeShiftFlag = false
    @backButtonEventFlag = false
    @headerVisibility = $('header').hasClass("header--visible")

    history.replaceState({popupPage: false, hrefPage: self.prevHref}, self.prevTitle, self.prevHref)

    staticPageContainers = '.article-page__right-side, .static-page__content-wrapper, .static-page__content-actions, .button-to-top--popup-page'
    # закрытие всплывающего окна при клике вне его
    $('.popup-overlay').click (event) ->
      if ($(window).width() >= '1104')
        if self.popupPageOpen
          if $(event.target).closest(staticPageContainers).length
            return
          self.closePopup()
          document.title = window.defaultPageTitle

    @initPopupLinks()
    @initPopupScroll()

    # Для работы кнопки назад в браузере
    window.onpopstate = (event) ->
      event.preventDefault()
      if self.popupPageOpen
        self.backButtonEventFlag = true
        self.closePopup()
      else
        if event.state
          if event.state.popupPage
            self.backButtonEventFlag = true
            self.loadPage(event.state.hrefPage)


    #убираем z-index у элементов списка новостей, чтобы они не появлялись на всплывахах
#    $('.popup-block-link').on 'click', ->
#      $('.grid-news-list').removeClass('shading-block--content-active')


# инициализируем ссылки, которые открываются во всплывающем окне
  initPopupLinks: ->
    self = this
    $popupOpenLink = $('.popup-block-link') # Ссылка, которая будет открыватся во всплывающем окне

    $popupOpenLink.each(
      ->
        unless $(this).attr("data-event-init") == "true"
          # вешаем на ссылку атрибут, не позволяющий повторно повешать на неё событие открытия
          $(this).attr("data-event-init", "true") 
          # событие клика на ссылку
          $(this).click (e)->
            self.windowPosition = window.pageYOffset
            e.preventDefault()
            popupPageHref = $(this).attr('href')
            self.loadPage(popupPageHref)
    )



  loadPage: (popupPageHref)->
    self = this

    #    if window.location.pathname != popupPageHref
    $.ajax
      url: popupPageHref
      type: 'GET'
      dataType: 'html'
      data: {'ajax_load_page': true}
      success: (data) ->
        meta_title = $(data).find('h1').html()
        self.prevHref = window.location.pathname
        self.prevTitle = document.title

        self.$popupBlockContent.html(data)
        document.title = meta_title

        unless self.popupPageOpen
          self.togglePopupPage()
          history.pushState({popupPage: true, hrefPage: popupPageHref}, meta_title, popupPageHref)

        window.publication_page = undefined
#        new window.Video()
        # взял из togglePopupPage
        self.initPopupCloseButton()
        setTimeout(
          ->
            $('.b-page').addClass('b-page--hidden')
        , 100)
        $('.popup-overlay').scrollTop(0)

        setTimeout(
          ->
            self.initPopupLinks()
        , 1000)




# открытие/закрытие всплывабщего окна
  togglePopupPage: ->
    unless @popupPageAnimate
      @popupPageAnimate = true
      self = this

      if @popupPageOpen
        self.closePopup()
      else
        self.openPopup()


  openPopup: ->
    self = this
    self.windowPosition = $(document).scrollTop()
#    $('header').addClass('header--visible');
#    if window.headerObject.popupPageOpen
#      window.headerObject.siteMapClose()
#    if window.searchObject.popupPageOpen
#      window.searchObject.closeSearch()
#    window.headerObject.hideNavigationWindowArrow()
#    if $(window.headerObject.tabNavigation)
#      window.headerObject.tabNavigationHide()

    setTimeout(
      ->
        $('.line-vertical').addClass('line-vertical--article')
        $('.b-page').css('position', 'relative')
        $('.b-page').css('top', (-self.windowPosition)+'px')
        $('body').addClass('body-overflow')
#        $('.b-page').addClass('b-page--hidden')
#        $('.gosbar').removeClass('gosbar--scroll-state')
        $('header').removeClass('header--fixed')

        if (self.headerVisibility == false)
          $('header').addClass('header--visible');
#        self.headerPositionToggle()
    , 250)

    @$popupBlock.addClass(@popupBlockOpenClass)
    @popupPageOpen = true
    self.endAnimationPopup()



  closePopup: ->
    self = this
    $('body').removeClass('body-overflow')
    $('.b-page').removeClass('b-page--hidden')
    @$popupBlock.removeClass('popup-overlay--fixed-header')
    if (self.headerVisibility == false)
      $('header').removeClass('header--visible');

    unless self.backButtonEventFlag
      window.pageInitFlag = false
      history.replaceState({popupPage: false, hrefPage: self.prevHref}, self.prevTitle, self.prevHref)

    self.backButtonEventFlag = false
#    window.headerObject.showNavigationWindowArrow()
#    if $(window.headerObject.tabNavigation)
#      window.headerObject.tabNavigationShow()
    setTimeout(
      ->

        self.popupPageOpen = false
#        window.headerObject.sitesListPageOpen = false

        self.$popupBlockContent.html('')

#        window.headerObject.editHeaderPosition()
        $('.b-page').css('position', 'relative')
        $('.b-page').css('top', 0)
        $(document).scrollTop(self.windowPosition)
    , 500)

    setTimeout(
      ->
        $('.line-vertical--article').css('display', 'block')
        $('.line-vertical').removeClass('line-vertical--article')
    , 125)

    @$popupBlock.removeClass(@popupBlockOpenClass)
    self.endAnimationPopup()

    window.pageInitCommonFlag = false



  endAnimationPopup: ->
    self = this
#    window.shading.shadingDisable(window.shadingContent, 0)
    setTimeout(
      ->
        self.popupPageAnimate = false
        self.$popupBlock.scrollTop(0)
    , 1000)



# из togglePopupPage вынес инициализацию кнопки в отдельный метод
  initPopupCloseButton: ->
    self = this

    $('.js-button-close-block').click (event) ->
      event.preventDefault()
      if $(this).attr('href') == undefined
        self.closePopup()
        document.title = window.defaultPageTitle


#  toggleBottomHiddenBlock: (blockId) ->
#    self = this
#    self.activeHiddenField = blockId
#    if (!self.animationFlag)
#      $('.static-page__shading-mask').toggleClass('static-page__shading-mask--active')
#      self.animationFlag = true
#      $('#hf_' + self.activeHiddenField).slideToggle()
#      setTimeout(
#        ->
#          self.animationFlag = false
#      , 500)


  initPopupScroll: ->
    self = this
    # переключаем состояния header на всплывающих окнах при скроле
    $('.popup-overlay').scroll ->
      if self.popupPageOpen
        if $('.popup-overlay').scrollTop() > 48
          $('header').addClass('header--fixed')
        else
          $('header').removeClass('header--fixed')



// WEBPACK FOOTER //
// ./assets/javascripts/app/page_popup.coffee